import { render, staticRenderFns } from "./ImageGridItem.vue?vue&type=template&id=0ed54404&"
import script from "./ImageGridItem.vue?vue&type=script&lang=js&"
export * from "./ImageGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageGridItem.vue?vue&type=style&index=0&id=0ed54404&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
